/**
 * @generated SignedSource<<2a2e4c104c7116b9e3e7d2de0c6550da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetTaskCollection_widgetTaskCollection$data = {
  readonly id: string;
  readonly taskSections: ReadonlyArray<{
    readonly id: string;
    readonly inProgressTaskExecution: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskMultipleRenderTask_taskExecution">;
    } | null;
    readonly section: {
      readonly id: string;
      readonly title: string | null;
    };
    readonly task: {
      readonly id: string;
      readonly routine: {
        readonly id: string;
        readonly title: string;
      };
      readonly title: string;
    };
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetTaskCollection_widgetTaskCollection";
};
export type WidgetTaskCollection_widgetTaskCollection$key = {
  readonly " $data"?: WidgetTaskCollection_widgetTaskCollection$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskCollection_widgetTaskCollection">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = [
  (v0/*: any*/),
  (v1/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTaskCollection_widgetTaskCollection",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "taskSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "task",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Routine",
              "kind": "LinkedField",
              "name": "routine",
              "plural": false,
              "selections": (v2/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "inProgressTaskExecution",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "WidgetTaskMultipleRenderTask_taskExecution"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTaskCollection",
  "abstractKey": null
};
})();

(node as any).hash = "62905e40b9c2095e5a5d39ff170fb5d7";

export default node;
